import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ModalMap from './modalMap';

const Table = props => (
  <div className="table-wraper">
    <div className="tabl-header">
      <table cellPadding="0" cellSpacing="0" border="0">
        <thead>
          <tr>
            <th className="bd f-family">
              <a role="button" tabIndex={0}>
                {props.language.account.accountAssigment.team}
                <i className="fas fa-arrows-alt-v assignment" />
              </a>
            </th>
            <th className="bd f-family">
              <a role="button" tabIndex={0}>
                {props.language.account.accountAssigment.driver}
                <i className="fas fa-arrows-alt-v assignment" />
              </a>
            </th>
            <th className="bd f-family">
              <a role="button" tabIndex={0}>
                {props.language.account.accountAssigment.assignDate}
                <i className="fas fa-arrows-alt-v assignment" />
              </a>
            </th>
            <th className="bd f-family">
              <a role="button" tabIndex={0}>
                {props.language.account.accountAssigment.assignTime}
                <i className="fas fa-arrows-alt-v assignment" />
              </a>
            </th>
            <th className="bd f-family">
              <a role="button" tabIndex={0}>
                {props.language.account.accountAssigment.detail}
              </a>
            </th>
          </tr>
        </thead>
      </table>
    </div>
    <div className="tabl-content">
      <table cellPadding="0" cellSpacing="0" border="0">
        <tbody>
          {props.datos.map((item, i) => (
            <tr key={i} className={item.isAssigned ? 'row-green' : 'row-gray'}>
              <td className={item.isAssigned ? 'bd-green center' : 'bd-gray center'}>
                {item.vehicleAlias}
              </td>
              <td className="center">{item.driverAlias}</td>
              <td className="center">
                {item.from ? moment(item.from).format('DD-MM-YYYY H:mm:ss ') : ''}
              </td>
              <td className="center">
                {item.to ? moment(item.to).format('DD-MM-YYYY H:mm:ss ') : ''}
              </td>
              <td className="center map-icon">
                {!item.isAssigned ? (
                  <div className="map-tooltip">
                    <i
                      className="fas fa-map-marker-alt icon-border"
                      onMouseOver={props.handleMOuseOver}
                      data-index={i}
                      data-size={props.datos.length}
                    />
                    <div
                      className={
                        props.datos.length - i < 9 ? 'tooltip-left mystyle' : 'tooltip-left'
                      }
                      id="tooltip-left"
                    />
                  </div>
                ) : (
                  'Sin datos'
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default Table;



// WEBPACK FOOTER //
// ./source/client/components/assignment_list/table.jsx